import React from 'react';
import { ContainerMiniModal, InputValorDescricao } from './styles'


class MiniModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value
    }
  }

  // componentDidMount() {
  //   const a = document.getElementById("input-valor-unitario-tabela-itens-proposta");
  //   a.focus();
  // }
  getValue() {
    return { descricao_detalhada: this.state.value }
  }

  handleChange = (e) => {
    let { value } = e.target;
    if(value.length > 5000)
    return;
    this.setState({ value })
  }

  getInputNode() {
    // If applicable, should return back the primary html input node that is used to edit the data
    // Otherwise return null
    // If value is an input node, then this node will be focussed on when the editor opens
  }

  disableContainerStyles() {
    // Optional method
    // If set to true, the EditorContainer will not apply default styling to the editor
  }

  render() {
    return (
      <ContainerMiniModal>
        <InputValorDescricao
          id="input-valor-unitario-tabela-itens-proposta"
          type="textarea"
          onChange={this.handleChange}
          value={this.state.value}
        />
        <div style={{position: 'absolute', display: "flex", justifyContent: 'center', top: "calc(100% - 18px)", fontSize: '12px',  fontFamily: 'Arial, Helvetica, sans-serif'}}>
          <span style={{color: this.state.value.length === 5000 ? "#ab2e46" : "#212529" }}>{this.state.value.length}/5000</span>
        </div>
      </ContainerMiniModal>
    )
  }
}

export default MiniModal;